import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import { RestaurantService } from '../../../services/Restaurant.service';

export interface DialogData {
  selectedItems: any[],
  restaurantId: number,
  name: {
    title_EN: string
    title_AR: string
  }
  index: number
  sizesList: any[]
}

@Component({
  selector: 'app-custom-sizes-form',
  templateUrl: './custom-sizes-form.component.html'
})
export class CustomSizesFormComponent extends DirtyComponent implements OnInit {

  override formGroup!: FormGroup;
  dataLoading = false;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = (this.data.name.title_EN && this.data.name.title_AR) ? true : false;
  sections: any[] = []

  constructor(
    override dialogRef: MatDialogRef<CustomSizesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: RestaurantService,
    translate: TranslateService
  ) { super(translate); }

  ngOnInit(): void {
    this.buildForm();

    this.sections = JSON.parse(JSON.stringify(this.data.selectedItems));
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }

    console.log(JSON.parse(JSON.stringify(this.data.sizesList)))
    console.log(JSON.parse(JSON.stringify(this.data.selectedItems)))

  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.enTxt)
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.arTxt)
      ]],
    });
  }

  bindDataToUpdate() {
    this.formGroup.patchValue({
      title_EN: this.data.name.title_EN,
      title_AR: this.data.name.title_AR
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  validateDuplicate(ctrName: string) {
    this.data.selectedItems.forEach((item, index) => {
      if (
        item.name[ctrName] === this.formGroup.controls[ctrName].value
        && index != this.data.index
      ) {
        this.formGroup.controls[ctrName].setErrors({ 'duplicated': true })
      }
    });

    this.data.sizesList.forEach((item, index) => {
      if (
        item[ctrName] === this.formGroup.controls[ctrName].value
        && index != this.data.index
      ) {
        this.formGroup.controls[ctrName].setErrors({ 'duplicated': true })
      }
    });
  }

  saveRecord() {
    this.isSubmitted = true;
    this.validateDuplicate('title_EN')
    this.validateDuplicate('title_AR')
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        restaurantSizeId: 0,
        name: {
          title_EN: this.formGroup.controls['title_EN'].value,
          title_AR: this.formGroup.controls['title_AR'].value
        },
        sizeClassificationId: 0
      };

      this.dialogRef.close(data);
    }
  }

}
